import { render, staticRenderFns } from "./AmetrasSignatureCaptureTemplate.vue?vue&type=template&id=0792f2d8&scoped=true&"
import script from "./AmetrasSignatureCaptureTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasSignatureCaptureTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasSignatureCaptureTemplate.vue?vue&type=style&index=0&id=0792f2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0792f2d8",
  null
  
)

export default component.exports